import _export from '../internals/export.js';

var $ = _export; // `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon

$({
  target: 'Number',
  stat: true
}, {
  EPSILON: Math.pow(2, -52)
});
